import Helper from './Helper';

class ATime {
  constructor(timeEstimated = null, timeTimetabled = null, estimatedLast = true) {
    this.element = document.createElement('span');
    this.element.classList.add('a-time');

    this.dateToLocaleTimeString = (date) => (new Date(date)).toLocaleString('de-DE', {
      timeStyle: 'short',
    });

    let html = '';
    if (timeTimetabled !== null && timeTimetabled !== timeEstimated) {
      const timeDifference = (
        ((new Date(timeEstimated)).getTime() - (new Date(timeTimetabled)).getTime()) / 60000
      ); // in minutes
      let errorLevel = 'error';
      if (timeDifference < 5) {
        errorLevel = 'info';
      }

      if (estimatedLast) {
        html += `
          <time datetime="${Helper.escapeHtml(timeTimetabled)}" class="a-time__timtabled -delayed">
            <span class="a-visually-hidden">ursprünglich</span>
            ${this.dateToLocaleTimeString(timeTimetabled)}
            <span class="a-visually-hidden">(verspätet)</span>
          </time>
          <time datetime="${Helper.escapeHtml(timeEstimated)}" class="a-time__estimated -${errorLevel}">
            <span class="a-visually-hidden">voraussichtlich </span>
            ${this.dateToLocaleTimeString(timeEstimated)}
          </time>
        `;
      } else {
        html += `
          <time datetime="${Helper.escapeHtml(timeEstimated)}" class="a-time__estimated -${errorLevel}">
            <span class="a-visually-hidden">voraussichtlich </span>
            ${this.dateToLocaleTimeString(timeEstimated)}
          </time>
          <time datetime="${Helper.escapeHtml(timeTimetabled)}" class="a-time__timtabled -delayed">
            <span class="a-visually-hidden">ursprünglich</span>
            ${this.dateToLocaleTimeString(timeTimetabled)}
            <span class="a-visually-hidden">(verspätet)</span>
          </time>
        `;
      }
    } else {
      html += `
        <time datetime="${Helper.escapeHtml(timeEstimated)}" class="a-time__estimated">
          ${this.dateToLocaleTimeString(timeEstimated)}
        </time>
      `;
    }

    this.element.innerHTML = html;
  }
}

export default ATime;
